import script from "./MyToolTip.vue?vue&type=script&setup=true&lang=js"
export * from "./MyToolTip.vue?vue&type=script&setup=true&lang=js"

import "./MyToolTip.vue?vue&type=style&index=0&id=43546fe5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43546fe5"]])

export default __exports__